import { render } from "./CardServiceBloc.component.vue?vue&type=template&id=5b9e680a"
import script from "./CardServiceBloc.component.vue?vue&type=script&lang=js"
export * from "./CardServiceBloc.component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/searchFind/cardType/CardServiceBloc.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b9e680a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b9e680a', __exports__)) {
    console.log('reload')
    api.reload('5b9e680a', __exports__)
  }
  
  module.hot.accept("./CardServiceBloc.component.vue?vue&type=template&id=5b9e680a", () => {
    console.log('re-render')
    api.rerender('5b9e680a', render)
  })

}


export default __exports__